export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crear nuevo pallet"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver al contenedor"])},
          "add_package_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar paquete nuevo"])},
          "add_assigned_package_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Asignar paquete existente"])},
          "new_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar pallet"])},
          "save_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crear"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])}
        }
      }
    }
  })
}